// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"a4e99f51","746":"5d11fb2e","858":"0145e389"}[chunkId] + ".chunk.js";
};